import {
  documentErrorsLocales as libDocumentErrorLocales,
  SHINE_START_DOCUMENT_ERRORS,
} from '@shinetools/shine-start-library';
import LocalizedStrings from 'localized-strings';

import { ShineStartDocument } from 'features/Onboarding/shineStartTypes';

import locales from './locales';

const documentErrorsLocales = new LocalizedStrings(libDocumentErrorLocales);

const getShineStartDocumentError = (
  shineStartDocument: Pick<ShineStartDocument, 'error' | 'errorLocalized'>,
): string => {
  if (shineStartDocument.error === null) {
    return locales.fallbackErrorMessage;
  }
  if (
    shineStartDocument.error in documentErrorsLocales &&
    shineStartDocument.error !== SHINE_START_DOCUMENT_ERRORS.GENERIC
  ) {
    const locale =
      documentErrorsLocales[
        shineStartDocument.error as keyof typeof SHINE_START_DOCUMENT_ERRORS
      ];
    return `${locale.label}${locales.errorTextJoin}${locale.description}`;
  }
  const shouldUseErrorLocalized =
    !(shineStartDocument.error in documentErrorsLocales) ||
    shineStartDocument.error === SHINE_START_DOCUMENT_ERRORS.GENERIC;
  if (shouldUseErrorLocalized && shineStartDocument.errorLocalized !== null) {
    return shineStartDocument.errorLocalized;
  }
  return locales.fallbackErrorMessage;
};

export default getShineStartDocumentError;
